import ContainerToken, { TContainer } from './containers'
import SpacingToken, { TSpacing } from './spacing'

export default {
  spacing: SpacingToken,
  containers: ContainerToken,
}

export type TLayoutV2 = TSpacing | TContainer
